module.exports = __webpack_public_path__ + "site/img/37.b26eff04.jpg";